import React, { createContext, useMemo } from 'react';
import SplashScreen from 'src/components/SplashScreen';
import { FETCH_SHORT_USER } from "src/constants/graphql";
import { useQuery } from "@apollo/client/react";

const initialState = {
  user: null,
  loading: true,
  accessToken: null,
};

const fetchInvitationToken = () => {
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search.slice(1));

  return params.get('invitation-token');
}

const InvitationAuthContext = createContext({
  ...initialState,
});

export const InvitationProvider = ({ children }) => {
  const accessToken = fetchInvitationToken()

  const { loading, data: userData } = useQuery(
    FETCH_SHORT_USER,
    {
      variables: { accessToken },
    }
  );

  const state = useMemo(() => {
    if (loading) return { user: null, loading: true, accessToken };

    const invitationUser = userData?.invitationUser;
    const user = invitationUser?.email ? invitationUser : null;
    return { user, loading: false, accessToken };
  }, [loading, userData, accessToken]);

  if (loading) {
    return <SplashScreen />
  }

  return (
    <InvitationAuthContext.Provider value={state}>
      {children}
    </InvitationAuthContext.Provider>
  );
};

export default InvitationAuthContext;
